export default __webpack_public_path__ + "static/profile-card-jessica-d2b94002c5b48cafefe9ad5489228839.jpeg";